<template>
  <div id="app">
    <div v-if="isLoginPage" style="width: 100%;height: 100%;min-height: 685px;">
      <div v-if="inUpperPage" style="background: #194887;display: flex;justify-content: flex-start;flex-direction: column;height: 100%;">
        <upper-strata-common-top />
        <div class="main2" >
          <router-view v-if="!$route.meta.keepAlive && viewChange" v-show="viewChange" style="flex: 1;" class="view3" name="firstPage" />
          <div style="width: 100%;display: flex;justify-content: flex-start;align-items: flex-start;margin-top: 20px;" v-if="$route.name !== 'summary-page'">
            <router-view class="view1" />
            <transition name="el-zoom-in-bottom">
              <div style="flex: 1;display: flex;justify-content: flex-start;flex-direction: column;margin-right: 10px;height: 100%;">
                <keep-alive>
                  <router-view v-if="$route.meta.keepAlive && viewChange" v-show="viewChange" class="view2" name="a" />
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive && viewChange" v-show="viewChange" class="view2" name="a" />
              </div>
            </transition>
          </div>
        </div>
      </div>
      <router-view v-if="!inUpperPage" />
    </div>
    <div v-if="inPage" class="bgcolor" :class="{ bgColor_inHomePage: inHomePage }">
      <nav-menu />
      <nav-tabs />
      <div class="main" :class="{ main_inHomePage: inHomePage, v2IframeMain: inIframePage}">
        <router-view class="view1" />
        <transition name="el-zoom-in-bottom">
          <div style="flex: 1;display: flex;justify-content: flex-start;flex-direction: column;overflow-y: auto;">
            <div style="flex: 1;display: flex;justify-content: flex-start;flex-direction: column;overflow-y: auto;">
              <keep-alive>
                <router-view v-if="$route.meta.keepAlive && viewChange" v-show="viewChange" class="view2" :class="{ v2IframePage: inIframePage }" name="a" />
              </keep-alive>
              <router-view v-if="!$route.meta.keepAlive && viewChange" v-show="viewChange" class="view2" :class="{ v2IframePage: inIframePage }" name="a" />
            </div>
            <foot-text />
          </div>
        </transition>
        <!--<transition name="el-zoom-in-bottom" v-if="!$route.meta.keepAlive">-->
          <!--<router-view v-if="viewChange" v-show="viewChange" class="view2" :class="{ v2IframePage: inIframePage }" name="a" />-->
        <!--</transition>-->
      </div>

    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import NavMenu from "./components/NavMenu/NavMenu";
import NavTabs from "./components/NavTabs/NavTabs";
import FootText from "./components/FootText/FootText";
import {
  bus,
  getAccountCode,
  getAccountName,
  getYqCode,
  getPermissionCodes,
  getToken,
  getYqName,
  getUpperData
} from "./utils/bus";
import UpperStrataCommonTop from "./view/UpperStrata/UpperStrataCommonTop";
import {api} from './view/api/Login'
import {errorHandler} from './utils/errorHandler'
import {errorMessage} from "./utils/errorCode";

export default {
  components: {
    UpperStrataCommonTop,
    FootText,
    NavMenu,
    NavTabs
  },
  name: "App",
  data() {
    return {
      isLoginPage: false,
      inPage: false,
      inUpperPage: false,
      inHomePage: false,
      inIframePage: false,

      viewChange: true
    };
  },
  created() {
    let isLoginFree = this.$route.query.isLoginFree;
    let bindLogin = this.$route.query.bindLogin;
    let accountCode = this.$route.query.a;
    let token = this.$route.query.t;
    let yqCode = this.$route.query.y;
    if (accountCode) {
      window.sessionStorage.setItem("accountCode", accountCode);
      bus.global.accountCode = accountCode;
    }
    if (token) {
      window.sessionStorage.setItem("token", token);
      bus.global.token = token;
    }
    if (yqCode) {
      window.sessionStorage.setItem("yqCode", yqCode);
      bus.global.yqCode = yqCode;
    }
    if (isLoginFree) {
      this.loginForAvoid()
      return
    }
    if (bindLogin) {
      console.log('enter')
      let { yqAppCode }=this.$route.query
      let { accountCode }=this.$route.query
      let { applyType }=this.$route.query
      this.$axios.post(`${api.bindLogin}/${accountCode}/${yqAppCode}`,{}).then(res=>{
        if (res.data.retCode === 1) {
          let data = res.data.data
          window.sessionStorage.setItem('accountCode', res.data.data.code)
          window.sessionStorage.setItem('accountName', res.data.data.name)
          window.sessionStorage.setItem('accountPersonCode', data.personCode)
          window.sessionStorage.setItem('accountPersonName', data.personName)
          window.sessionStorage.setItem('token', res.data.data.token)
          window.sessionStorage.setItem('permissionCodes', res.data.data.permissionCodes)
          window.sessionStorage.setItem('yqCode', yqAppCode)
          bus.global.accountCode = res.data.data.code
          bus.global.accountName = res.data.data.name
          bus.global.personCode = data.personCode
          bus.global.personName = data.personName
          bus.global.token = res.data.data.token
          bus.global.yqCode = yqAppCode
          bus.global.permissionCodes = res.data.data.permissionCodes
          if(applyType==='1'){
            window.sessionStorage.setItem('navTop', 'contract-approval')
            this.$router.push({
              name: 'contract-approval'
            })
          }else if(applyType==='2'){
            window.sessionStorage.setItem('navTop', 'contract-approval')
            this.$router.push({
              name: 'electricity-approval'
            })
          }else if(applyType==='3'){
            window.sessionStorage.setItem('navTop', 'contract-approval')
            this.$router.push({
              name: 'revise-approval'
            })
          }else if(applyType==='4'){
            window.sessionStorage.setItem('navTop', 'contract-approval')
            this.$router.push({
              name: 'water-approval'
            })
          }else if(applyType==='11'){
            window.sessionStorage.setItem('navTop', 'contract-approval')
            this.$router.push({
              name: 'free-code-approval'
            })
          }else if(applyType==='12'){
            window.sessionStorage.setItem('navTop', 'contract-approval')
            this.$router.push({
              name: 'repair-approval'
            })
          }else{
            window.sessionStorage.setItem('navTop', 'workbench')
            this.$router.push({
              name: 'workbench'
            })
          }
        }
      }).catch(e=>{
        this.$layer.toast({
          icon: 'icon-check',
          content: errorMessage(+e.response.data.data),
          time: 1000
        })
      })
      return
    }
    getAccountCode();
    getAccountName();
    getYqCode();
    getYqName();
    getToken();
    getPermissionCodes();
    getUpperData();

    if (
      this.$route.name === "homepage" ||
      this.$route.name === "workbench" ||
      this.$route.name === "workbench-3"
    ) {
      this.inHomePage = true;
    } else {
      this.inHomePage = false;
    }
    if (
      this.$route.name === "login" ||
      this.$route.name === "wx-login" ||
      this.$route.name === "wx-login-bind-account" ||
      this.$route.name === "resetPassword" ||
      this.$route.name === "first-change-password" ||
      this.$route.name === "login-liantong" ||
      this.$route.name === "login-3i" ||
      this.$route.name === "login-zjrob" ||
      this.$route.name === "corporate-portrait" ||
      this.$route.path.indexOf("upper_strata") !== -1 ||
      this.$route.name === "upper-login" ||
      this.$route.name === "login-free"
    ) {
      this.isLoginPage = true;
      this.inPage = false;
      if (
        this.$route.path.indexOf("upper_strata") !== -1 &&
        this.$route.path !== "/upper_strata/park_display_screen" &&
        this.$route.path !== "/upper_strata/park_display_screen2" &&
        this.$route.path !== "/upper_strata/intelligent_brain" &&
        this.$route.path.indexOf(
          "/upper_strata/portrait_of_enterprises_in_the_park"
        ) === -1
      ) {
        this.inUpperPage = true;
      } else {
        this.inUpperPage = false;
      }
    } else if (!this.$route.name) {
      this.inPage = false;
      this.isLoginPage = false;
    } else {
      this.inPage = true;
      this.isLoginPage = false;
    }
    if (this.$route.name === "parking-service-page") {
      this.inIframePage = true;
    } else {
      this.inIframePage = false;
    }

    if (this.$route.name !== "login-free") {
      let accountCode = bus.global.accountCode;
      if (
        !accountCode &&
        this.$route.name !== "wx-login" &&
        this.$route.name !== "wx-login-bind-account" &&
        this.$route.name !== "login-liantong" &&
        this.$route.name !== "login-3i" &&
        this.$route.name !== "login-zjrob" &&
        (this.$route.path.indexOf("upper_strata") === -1 ||
          this.$route.path.indexOf(
            "/upper_strata/portrait_of_enterprises_in_the_park"
          ) !== -1 ||
          this.$route.path.indexOf("/upper_strata/park_display_screen") !==
            -1 ||
          this.$route.path.indexOf("/upper_strata/park_display_screen2") !==
            -1 ||
          this.$route.path.indexOf("/upper_strata/intelligent_brain") !== -1) &&
        this.$route.name !== "upper-login"
      ) {
        if (this.$route.name !== "ParkDisplayScreen2") {
          this.$router.push({
            name: "login"
          });
        }
      }
      let upperAccountCode = bus.global.upperData.accountName;
      if (
        !upperAccountCode &&
        this.$route.path.indexOf("upper_strata") !== -1 &&
        this.$route.path.indexOf(
          "/upper_strata/portrait_of_enterprises_in_the_park"
        ) === -1 &&
        this.$route.path.indexOf("/upper_strata/park_display_screen") === -1 &&
        this.$route.path.indexOf("/upper_strata/park_display_screen2") === -1 &&
        this.$route.path.indexOf("/upper_strata/intelligent_brain") === -1
      ) {
        this.$router.push({
          name: "upper-login"
        });
      }
    }
  },
  methods: {
    loginForAvoid () {
      let timestamp = Date.parse(new Date())
      this.$axios.post(`${api.loginForAvoid}?yqAppCode=${bus.global.yqCode}&timestamp=${timestamp}&sign=${md5(bus.global.yqCode + timestamp.toString())}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            window.sessionStorage.setItem('accountCode', res.data.data.code)
            window.sessionStorage.setItem('accountName', res.data.data.name)
            window.sessionStorage.setItem('accountPersonCode', data.personCode)
            window.sessionStorage.setItem('accountPersonName', data.personName)
            window.sessionStorage.setItem('token', res.data.data.token)
            window.sessionStorage.setItem('permissionCodes', res.data.data.permissionCodes)
            window.sessionStorage.setItem('yqCode', res.data.data.parkCode)
            bus.global.accountCode = res.data.data.code
            bus.global.accountName = res.data.data.name
            bus.global.personCode = data.personCode
            bus.global.personName = data.personName
            bus.global.token = res.data.data.token
            bus.global.yqCode = res.data.data.parkCode
            bus.global.permissionCodes = res.data.data.permissionCodes
            window.sessionStorage.setItem('navTop', 'workbench')
            this.$router.push({
              name: 'workbench'
            })
          }
        })
        .catch(errorHandler('登录失败'))
    },
  },
  watch: {
    $route(v) {
      this.viewChange = false;
      setTimeout(() => {
        this.viewChange = true;
      });
      if (
        v.name === "login" ||
        this.$route.name === "wx-login" ||
        this.$route.name === "wx-login-bind-account" ||
        this.$route.name === "resetPassword" ||
        this.$route.name === "first-change-password" ||
        this.$route.name === "login-liantong" ||
        this.$route.name === "login-3i" ||
        this.$route.name === "login-zjrob" ||
        this.$route.name === "corporate-portrait" ||
        this.$route.path.indexOf("upper_strata") !== -1 ||
        this.$route.name === "upper-login" ||
        this.$route.name === "login-free"
      ) {
        this.isLoginPage = true;
        this.inPage = false;
        if (
          this.$route.path.indexOf("upper_strata") !== -1 &&
          this.$route.path !== "/upper_strata/park_display_screen" &&
          this.$route.path !== "/upper_strata/park_display_screen2" &&
          this.$route.path !== "/upper_strata/intelligent_brain" &&
          this.$route.path.indexOf(
            "/upper_strata/portrait_of_enterprises_in_the_park"
          ) === -1
        ) {
          this.inUpperPage = true;
        } else {
          this.inUpperPage = false;
        }
      } else if (!v.name) {
        this.inPage = false;
        this.isLoginPage = false;
      } else {
        this.inPage = true;
        this.isLoginPage = false;
      }
      if (
        this.$route.name === "homepage" ||
        this.$route.name === "workbench" ||
        this.$route.name === "workbench-3"
      ) {
        this.inHomePage = true;
      } else {
        this.inHomePage = false;
      }
      if (this.$route.name === "parking-service-page") {
        this.inIframePage = true;
      } else {
        this.inIframePage = false;
      }
    }
  }
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  min-width: 1400px;
  min-height: 685px;
}

* {
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
  text-decoration: none;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  font-size: 14px;
  min-height: 100%;
  height: 100%;
}
.bgcolor {
  height: 100%;
  background-color: #eff1f5;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.bgColor_inHomePage {
  min-height: 100%;
  background-color: #ffffff !important;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
a:hover {
  cursor: pointer;
}
.main {
  flex: 1;
  height: 600px;
  display: flex;
  justify-content: space-between;
}
.main2 {
  flex: 1;
  display: flex;
  justify-content: space-between;
}
.main_inHomePage {
  flex: 1;
  height: auto !important;
}
.view1 {
}
.view2 {
  padding: 0 20px;
  flex: 1;
  background-color: #ffffff;
  margin: 15px 0 0 15px;
  border-radius: 8px;
  overflow-y: auto;
}
.view3 {
  flex: 1;
  background-color: #ffffff;
  overflow-y: auto;
}
.v2IframePage {
  padding: 0 !important;
}
.v2IframeMain {
  height: 800px !important;
}
.el-input--mini .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
.el-input--small .el-input__icon {
  height: 30px;
}
.el-input-number .el-input__inner {
  text-align: left;
}

.el-input-group__append {
  text-align: center;
  width: auto !important;
}
.el-input-group__prepend {
  text-align: center;
  padding: 0 5px !important;
  width: auto !important;
}
.the-tree {
  padding-top: 0 !important;
}
.discount-line .el-input-group__append,
.discount-line .el-input-group__prepend {
  padding: 0 20px !important;
}
.left_nav .el-menu-item-group .is-active {
  border-left: 0 !important;
}
.left_nav .el-menu-item-group .el-menu-item:hover,
.left_nav .el-menu-item-group .el-menu-item {
  border-left: 0 !important;
}
.el-tabs--top.el-tabs--card .el-tabs__item:last-child {
  width: auto !important;
}

.form-line > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > div div:last-child {
  flex: 1;
  line-height: 30px;
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #999999;
  background: #999999;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px #cccccc;
  border-radius: 10px;
  background: #ededed;
}
</style>

<style lang="less">
@import "components/CommonStyle/commonAddStyle";
@import "components/CommonStyle/commonSearch";
</style>



// WEBPACK FOOTER //
// src/App.vue